export default __webpack_public_path__ + "static/3-f9146e28b9d51642296d5770ef7c41b9.png";